export default __webpack_public_path__ + "static/media/MarnieFinal.338ba81d.png";